import { useContext, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ModalContext } from '../context/ModalProvider';
import Product from './Product';

export default function ProductList({ products }) {
    const { productSlug } = useParams();
    const navigate = useNavigate();

    // Auto-skip when there's exactly one intermediate group (not a final product)
    useEffect(() => {
        if (products.length === 1) {
            const only = products[0];
            const isFinalProduct = only.ProductList?.length > 0 || only.BMKGroups?.length > 0;
            if (!isFinalProduct) {
                let url = only.Id + '-' + encodeURIComponent(only.Name);
                if (productSlug) {
                    url = '/' + encodeURIComponent(productSlug.trim()) + '/' + url;
                }
                navigate(url, { replace: true });
            }
        }
    }, [products, productSlug, navigate]);

    const isModelList = products.length > 0 && products[0].ProductList && products[0].ProductList.length > 0;

    return (
        <div id="product_groups_container_content" className={isModelList ? 'groupContainerContent modelList' : 'groupContainerContent'}>
            {products.length === 0 ? (
                <div className="loader">Loading...</div>
            ) : (
                products.map((product) => {
                    if (product.ProductList?.length > 0 || product.BMKGroups?.length > 0) {
                        return <Product key={product.Id} product={product} />
                    } else {
                        return <ProductGroup key={product.Id} productGroup={product} />
                    }
                })
            )}
        </div>
    );
}

function ProductGroup({ productGroup }) {
    const { productSlug } = useParams();
    let url = productGroup.Id + '-' + encodeURIComponent(productGroup.Name);
    if (productSlug) {
        url = '/' + encodeURIComponent(productSlug.trim()) + '/' + url;
    }

    if (productGroup.IsProductSeries && !productGroup.Name.includes('Series')) {
        productGroup.Name += ' Series';
    }

    const sendEvent = () => {
        window.gtag('event', 'Product Line Selected', {
            'Product Line': productGroup.Name
        });
    }

    let highlightedUses = [];
    if (productGroup.HighlightedUses !== null) {
        highlightedUses = Object.values(productGroup.HighlightedUses).filter(use => use.Key);
    }

    const modal = useContext(ModalContext);
    const showDetails = (e) => {
        e.stopPropagation();
        e.preventDefault();

        modal.show(
            <div className="highlights-container">
                <h2 className="modal-title">{productGroup.Name} Details</h2>
                <div className="modal-image">
                    <img src={productGroup.ImageUrl} loading="lazy" />
                </div>
                <div className="modal-highlights">
                    <h2>Highlighted Uses</h2>
                    <ul>
                        {highlightedUses.map(use => (
                            <li key={use.Key}>
                                <h3>{use.KeyAlias}</h3>
                                <p>{use.Value}</p>
                            </li>
                        ))}
                    </ul>
                </div>
                <Link to={url} className="action-button" onClick={() => modal.show()}>Choose {productGroup.Name}</Link>
                <button onClick={() => modal.show()} className="action-button cancel">Back</button>
            </div>
        );
    }

    const searchRegExp = /[\/]/g;
    const replaceWith = ' / ';

    return (
        <Link to={url} onClick={sendEvent} className="productGroupLink groupLink eligible">
            {highlightedUses.length > 0 && (
                <span className="detailsLink" onClick={showDetails}><em className="bi bi-info-circle"></em> Details</span>
            )}
            <span className="groupThumbContainer">
                <img src={productGroup.ImageUrl} className="groupThumb thumb" alt={productGroup.Name} loading="lazy" />
            </span>
            <span className="headline">{productGroup.Name.replace(searchRegExp, replaceWith)}</span>
        </Link>
    );
}
